export const menuPartner = {
    menu: [
        {label: 'menu.OuvrirDossier', icon: '', url: '/accueil', children: []},
        {label: 'menu.candidatures', icon: '', url: '/dossiers/candidatures', children: []},
        {label: 'menu.projetsFinances', icon: '', url: '/dossiers/projets-finances', children: []},
    ],
    classKey: 'partner'
};
